export default {
      id: "gb-eng-usage",
      viewBox: "0 0 640 480",
      url: __webpack_public_path__ + "assets/flags-sprite.svg#gb-eng",
      toString: function () {
        return this.url;
      }
    }